import {h, Fragment} from "preact"
import { skeletonFilters } from "../config"

export default function Skeleton() {

    return (
        <div className="min-h-screen">
            <div className="h-full">
                <div className="bg-white w-full pt-5 lg:pt-8 px-5 lg:px-10 z-2">
                <div className="w-full flex flex-wrap justify-between">
                    <span className="body-2 lg:hidden" data-nosto-element="totalResults">
                        
                    </span>
                    <ul className="items-center hidden lg:flex gap-7 mb-7 filter-chosen:mb-8">
                        {skeletonFilters.map(
                            (filter) => (
                                <li key={filter}>
                                    <button
                                        className="flex items-center body-2 gap-1 after:block after:border-gray-900 after:border-b after:w-1.5 after:h-1.5 after:border-l after:-rotate-45 after:origin-center"
                                        type="button"
                                        aria-label="Open filters panel"
                                    >
                                    <span>{filter}</span>
                                    </button>
                                </li>
                            )
                        )}
                    </ul>
                    <div className="flex lg:flex-1 justify-end relative lg:items-start pb-5">
                        <button
                            className="lg:hidden flex items-center body-2 gap-1 after:block after:border-gray-900 after:border-b after:w-1.5 after:h-1.5 after:border-l after:-rotate-45 after:origin-center"
                            type="button"
                            aria-label="Open filters panel"
                        >
                            <span>Filters</span>
                        </button>
                        <div className="ns-dropdown-container">
                            <div>
                                <button
                                    className="flex justify-end items-center cursor-pointer w-fit"
                                    type="button"
                                    aria-haspopup="true"
                                    aria-controls="ns-sort-dropdown"
                                    aria-labelledby="sort-label"
                                    aria-expanded="false"
                                    tabIndex="0"
                                >
                                    <span
                                        className="body-2 pr-[5px] pl-[16px] cursor-pointer lg:pl-[30px]"
                                        id="sort-label"
                                    >
                                        Sort By:
                                    </span>
                                    <span className="body-2--medium hidden lg:inline">Featured</span>
                                    <svg className="lg:mr-[31.6px]" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Arrow down">
                                        <path d="M12 8L8 12L4 8" stroke="#2D2926" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                            <div
                                className="absolute bg-white m-w-full z-1"
                                id="ns-sort-dropdown"
                                aria-hidden="true"
                                tabIndex="0"
                            />
                        </div>
                        <div className="hidden w-[89px] h-[20px] body-2 lg:inline lg:relative lg:right-[0px] lg:left-auto bg-gray-200" />
                    </div>
                </div>
                </div>
                <div className="grid grid-cols-2 gap-1.5 gap-y-[1.375rem] mb-[30px] md:gap-y-[3.25rem] md:grid-cols-4 md:px-10">
                    {Array.from({ length: 12 }).map((_, index) => (
                        <div key={index}>
                            <div className="overflow-hidden aspect-[2/3]">
                                <div
                                    role="status"
                                    className="flex items-center justify-center aspect-[2/3] bg-gray-300 animate-pulse dark:bg-gray-400"
                                >
                                <svg
                                    className="w-10 h-10 text-gray-200 dark:text-gray-500"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 16 20"
                                >
                                    <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                                    <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM9 13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2Zm4 .382a1 1 0 0 1-1.447.894L10 13v-2l1.553-1.276a1 1 0 0 1 1.447.894v2.764Z" />
                                </svg>
                                <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div className="w-12 md:w-28 overflow-hidden mx-auto">
                                <div
                                    role="status"
                                    className="bg-gray-300 animate-pulse dark:bg-gray-400 w-12 md:w-28 mt-2.5 mx-auto"
                                >
                                    <div className="bg-gray-200 dark:bg-gray-500 w-12 md:w-28 h-[20px]" />
                                </div>
                            </div>
                            <div className="w-12 md:w-40 overflow-hidden mx-auto">
                                <div
                                    role="status"
                                    className="bg-gray-300 animate-pulse dark:bg-gray-400 w-12 md:w-40 mt-2.5 mx-auto"
                                >
                                    <div className="bg-gray-200 dark:bg-gray-500 w-12 md:w-40 h-[17px]" />
                                </div>
                            </div>
                            <div className="w-5 md:w-14 overflow-hidden mx-auto">
                                <div
                                    role="status"
                                    className="bg-gray-300 animate-pulse dark:bg-gray-400 w-5 md:w-14 mt-1 mx-auto"
                                >
                                    <div className="bg-gray-200 dark:bg-gray-500 w-5 md:w-14 h-[17px]" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
